import { render, staticRenderFns } from "./AddAccountModal.vue?vue&type=template&id=524bcf82&scoped=true&"
import script from "./AddAccountModal.vue?vue&type=script&lang=js&"
export * from "./AddAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAccountModal.vue?vue&type=style&index=0&id=524bcf82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524bcf82",
  null
  
)

component.options.__file = "AddAccountModal.vue"
export default component.exports